// src/config.ts

export const OPENWEATHER_API_KEY = process.env.REACT_APP_OPENWEATHER_API_KEY;
